// extracted by mini-css-extract-plugin
export default {"back-to-top":"Back2TopButton_back-to-top__RQaQ5","active":"Back2TopButton_active__4zdqB"};